export const
  RSVP =
  {
    ATTENDED: "Attending",
    DECLINED: "Declined",
    UNDECIDED : "Undecided"
  }